module.exports = __webpack_public_path__ + "static/assets/a3169a054b5f4ab7f02728cce82cf13d.svg";